import { configureStore } from "@reduxjs/toolkit";
import _ from "lodash";
import cartReducer from "./modules/cart/reducer";
import storeReducer from "./modules/store/reducer";
import checkoutReducer from "./modules/checkout/reducer";
import deliveryReducer from "./modules/delivery/reducer";
import productsReducer from "./modules/products/reducer";
import { completeCheckout } from "./modules/checkout/actions";
import { loadPersistedState, savePersistedState } from "./utils/persistence";

export function createAppStore(storage) {
  let persist;
  const persistCompletedCheckout = (api) => (next) => (action) => {
    const result = next(action);
    if (completeCheckout.match(action)) {
      persist.cancel();
      savePersistedState(api.getState(), storage);
    }
    return result;
  };
  const store = configureStore({
    reducer: {
      products: productsReducer,
      cart: cartReducer,
      store: storeReducer,
      delivery: deliveryReducer,
      checkout: checkoutReducer,
    },
    preloadedState: loadPersistedState(storage),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(persistCompletedCheckout),
  });
  persist = _.throttle(
    () => savePersistedState(store.getState(), storage),
    1000
  );
  store.subscribe(persist);
  store.flushPersistence = () => {
    persist.cancel();
    return savePersistedState(store.getState(), storage);
  };
  return store;
}

const store = createAppStore();
window.addEventListener("pagehide", store.flushPersistence);
export default store;
